import LanguageContext from "components/LanguageContext";
import Icon from "components/templatesComponents/Icon";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";

const iconStyled = () => ({
  pl: 1,
  display: "flex",
  alignItems: "center",
});

const TextIcon = (props) => {
  const { text, iconDSFR = "" } = props;

  const { language } = useContext(LanguageContext);

  return (
    <>
      {text}
      {iconDSFR && (
        <Icon iconDSFR={iconDSFR} size="sm" title={t[language].components.button_icon_title} sx={iconStyled()} />
      )}
    </>
  );
};

TextIcon.propTypes = {
  text: PropTypes.node,
  iconDSFR: PropTypes.string,
};

export default TextIcon;
